import { render, staticRenderFns } from "./CollectionUpdate.vue?vue&type=template&id=45b6daa4&"
import script from "./CollectionUpdate.vue?vue&type=script&lang=js&"
export * from "./CollectionUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports